import { Provider } from '@angular/core';
import { MODAL_REGISTRY } from '@features/modals/modal-registry.token';
import { PlinkoInfoModalComponent } from '@features/plinko/modals/plinko-info-modal/plinko-info-modal.component';

export function providePlinkoModals(): Provider[] {
  return [
    { provide: MODAL_REGISTRY, useValue: { key: 'PlinkoInfoModalComponent', component: PlinkoInfoModalComponent }, multi: true },
  ];
}
